// extracted by mini-css-extract-plugin
export default {"loader":"FullSpaseLoader_loader__YSHFm","loaderNot":"FullSpaseLoader_loaderNot__Z5hul"};